import React from 'react'
import { inject, observer } from 'mobx-react'
import { trackValue } from 'utils.js'
import MapInstruction from '../common/MapInstruction'
import ToolNote from '../common/ToolNote'
import { withTranslation } from 'react-i18next'
import ColorPicker from '../common/ColorPicker'
import { drawShape } from 'constants.js'
import PaneHeader from './PaneHeader'

const ShapePane = ({
  shape, group, uiStore, dataStore, selectionStore, t
}) => {
  const handleEdit = () => {
    shape.drawing = true
  }

  const handleConfirmAdd = (e) => {
    if (e && e.preventDefault) e.preventDefault()
    uiStore.addGeopolygon(group, shape)
  }

  const handleCancel = () => {
    selectionStore.clear()
  }

  const paneTitle = shape.isUpdating
    ? t('ITEM.EDIT_SHAPE', { defaultValue: 'Edit shape' })
    : t('ITEM.DRAW_SHAPE_TITLE', { defaultValue: 'Draw Shape' })

  const submitBtnText = shape.isUpdating
    ? t('GLOBAL.CONFIRM_SAVE', { defaultValue: 'Save shape' })
    : t('ITEM.CREATE_SHAPE_BTN', { defaultValue: 'Create shape' })

  return (
    <div className='line-pane'>
      <PaneHeader
        icon={drawShape}
        title={paneTitle}
        onClose={handleCancel}
      />

      <section>
        {
          shape.drawing
            ? (
                shape.points.length === 0
                  ? <MapInstruction>{t('ITEM.DRAW_SHAPE_START')}</MapInstruction>
                  : <MapInstruction>{t('ITEM.DRAW_SHAPE_CONTINUE')}</MapInstruction>
              )
            : null
        }
        {
          shape.tooLarge
            ? (
              <ToolNote type='warning'>
                {t('ITEM.GEOMETRY_TOO_LARGE')}
              </ToolNote>
              )
            : null
        }
      </section>

      <form className='spaced-children' onSubmit={handleConfirmAdd}>
        <section>
          <label>
            <span>{t('GLOBAL.NAME', { defaultValue: 'Name' })}</span>
            <input
              type='text'
              className='name-input'
              placeholder={t('ITEM.SHAPE_NAME_PLACEHOLDER', { defaultValue: 'e.g. Custom trade area' })}
              {...trackValue(shape, 'name')}
              autoFocus
            />
            <span className='invalid'>{shape.invalid.get('name')}</span>
          </label>
        </section>

        <section>
          <ColorPicker
            onClick={(idx) => { shape.color_id = idx }}
            selectedId={shape.color_id}
            hasTransparencyOption
            transparency={shape.transparency}
            onTransparencyChange={(val) => { shape.transparency = val }}
          />
        </section>

        <section>
          <div className='centered-button-row'>
            <button type='button' onClick={handleCancel}>
              <span>{t('GLOBAL.CANCEL', { defaultValue: 'Cancel' })}</span>
            </button>
            <button
              className='ok'
              type='submit'
              disabled={shape.drawing || shape.tooLarge}
            >
              <span>{submitBtnText}</span>
            </button>
          </div>
        </section>
      </form>

      {
        !shape.drawing && (
          <div>
            <button
              type='button'
              className='finish-line edit-buffer-button'
              onClick={handleEdit}
            >
              <span>{t('ITEM.COMPLETE_EDIT')}</span>
            </button>
          </div>
        )
      }
    </div>
  )
}

export default withTranslation()(inject('uiStore', 'dataStore', 'selectionStore')(observer(ShapePane)))
